import { useEffect, useState } from "react";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUp from "@mui/icons-material/KeyboardArrowUp";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import StarIcon from "@mui/icons-material/Star";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { ImageViewer } from "react-image-viewer-dv";
// Acromegaly React components
import MDBox from "components/MDBox";
import Swal from "sweetalert2";
import LoadingOverlay from "react-loading-overlay";
// Acromegaly React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PropTypes from "prop-types";
// Acromegaly React contexts
import { useMaterialUIController, setDirection } from "context";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import MDButton from "components/MDButton";
import { getOrdersList } from "controllers/OrderController";
import config from "config";
import MDTypography from "components/MDTypography";
import { getUsersList } from "controllers/UserController";
import AdapterJalali from "@date-io/date-fns-jalali";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import Footer from "examples/Footer";
import { updateOrderPin } from "controllers/OrderController";
import { getCollaboratorsAndsupperCollaboratorsList } from "controllers/UserController";
import { Image } from "@mui/icons-material";

function TablePaginationActions(props) {
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5, direction: "rtl" }}>
      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="صفحه اول">
        <LastPageIcon />
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        <KeyboardArrowRight />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="اخرین صفحه"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="صفحه قبلی"
      >
        <FirstPageIcon />
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

let filters = {
  userRole: "",
  canceled: false,
};
const sorts = {};
const productTypes = ["پلاک", "پلاک زنجیر", "گوشواره", "انگشتر", "دستبند"];
const buildTypes = ["لیزری", "ریخته گری", "دست ساز", "حک"];
const platings = ["بدون آبکاری", "طلایی", "رزگلد", "رادیوم"];
const orderStates = ["در انتظار طراحی", "در انتظار ساخت", "در انتظار ارسال"];
const allowedRoles = [
  "admin",
  "saleadmin",
  "saller",
  "designer",
  "production",
  "productionadmin",
  "supperadmin",
];
// const endUserContactTyps = ["اینستاگرام", "سایت", "حضوری"];
// const endUserSendTypes = ["تیپاکس", "پست پیشتاز", "پست ویژه", "کوشا", "باربری", "پیک", "حضوری"];
function Orders() {
  const [controller, dispatch] = useMaterialUIController();
  const [loading, setLoading] = useState(false);
  const [modal, setModal] = useState(false);
  const [count, setCount] = useState(0);
  const [filter, setFilter] = useState(filters);
  const [sort, setSort] = useState(sorts);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [open, setOpen] = useState();
  const [datas, setDatas] = useState([]);

  const [collaborators, setCollaborators] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const navigate = useNavigate();
  const location = useLocation();
  let emptyRows = rowsPerPage - Math.min(rowsPerPage, count - page * rowsPerPage);

  // Avoid a layout jump when reaching the last page with empty rows.
  const getData = async (perPagex, pagex, filterx, searchx, sortx) => {
    const filterme = filterx;
    if (location.pathname === "/activeorders") {
      filterme.activeOrders = true;
    } else {
      filterme.activeOrders = false;
    }
    setLoading(true);
    setDatas([]);
    const data = await getOrdersList(perPagex, pagex, searchx, filterme, sortx, controller.token);
    if (data.success) {
      setDatas(data.data);

      setCount(data.count);
      emptyRows = rowsPerPage - Math.min(rowsPerPage, datas.length - (pagex - 1) * rowsPerPage);
    } else {
      Swal.fire({
        text: data.message,
        icon: "error",
        confirmButtonText: "بسیار خوب",
      });

      if (data.code === 401) {
        navigate("/", { replace: true });
      }
    }

    setLoading(false);
  };
  const initDatas = async () => {
    setLoading(true);
    const userFilter = {
      userRole: "collaborator",
    };
    const res = await getCollaboratorsAndsupperCollaboratorsList(
      300,
      1,
      "",
      userFilter,
      controller.token
    );
    setLoading(false);

    if (res.success) {
      setCollaborators(res.data);
    } else {
      Swal.fire({
        text: `${res.message} (${res.code})`,
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
    }
    if (res.code === 401) {
      navigate("/", { replace: true });
    }
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getData(rowsPerPage, newPage + 1, filter, search, sort);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setFilter("");
    getData(parseInt(event.target.value, 10), 1, filter, search, sort);
  };
  const handleUpdatePinClick = async (id, pin) => {
    setLoading(true);
    let res = await updateOrderPin({ pin: !pin, id }, controller.token);
    setLoading(false);

    if (res.success) {
      getData(rowsPerPage, 1, filter, "", sort);
      // Swal.fire({
      //   html: res.message,
      //   icon: "success",
      //   confirmButtonText: "متوجه شدم",
      // });
    } else {
      Swal.fire({
        text: `${res.message} (${res.code})`,
        icon: "error",
        confirmButtonText: "متوجه شدم",
      });
    }
    if (res.code === 401) {
      navigate("/", { replace: true });
    }
  };

  const startPage = async () => {
    filters = {
      userRole: "",
    };
    setSort({});
    if (!controller.authenticated) {
      Swal.fire({
        text: "برای دسترسی به این صفحه باید وارد حساب کاربری خود شوید",
        icon: "error",
        confirmButtonText: "بسیار خوب",
      });
      navigate("/", { replace: true });
    } else {
      if (allowedRoles.filter((a) => a == controller.userRole).length > 0) {
        initDatas();
        getData(10, 1, filter, "", sort);
      } else {
        Swal.fire({
          text: "سطح دسترسی مناسب برای ورود به این صفحه را ندارید",
          icon: "error",
          confirmButtonText: "بسیار خوب",
        });
        navigate("/dashboard", { replace: true });
        return;
      }
    }
  };
  useEffect(() => {
    if (
      ["supperadmin", "saleadmin", "saller", "designer", "production", "productionadmin"].filter(
        (a) => a == controller.userRole
      ).length == 0
    ) {
      navigate("/dashboard", { replace: true });
      return;
    }
    setDirection(dispatch, "rtl");

    //

    startPage();
  }, []);
  useEffect(() => {
    getData(10, 1, filter, "", sort);
  }, [location.pathname]);

  return (
    <DashboardLayout>
      <DashboardNavbar title="لیست سفارشات" />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={1}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <Grid
                  container
                  spacing={1}
                  style={{
                    alignItems: "center",
                  }}
                >
                  <Grid item xs={12} sm={4}>
                    {location.pathname === "/activeorders" && (
                      <MDTypography variant="h6" fontWeight="medium" color="white">
                        سفارشات درحال اجرا
                      </MDTypography>
                    )}
                    {location.pathname === "/deactiveorders" && (
                      <MDTypography variant="h6" fontWeight="medium" color="white">
                        سفارشات ارسال شده
                      </MDTypography>
                    )}
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={8}
                    style={{
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    {location.pathname === "/activeorders" && (
                      <Grid
                        container
                        spacing={1}
                        style={{
                          justifyContent: "flex-end",
                          alignItems: "center",
                          marginTop: 1,
                        }}
                      >
                        {["supperadmin", "saleadmin", "saller", "productionadmin"].filter(
                          (a) => a == controller.userRole
                        ).length > 0 && (
                          <MDButton
                            style={{ marginLeft: 8 }}
                            variant="contained"
                            color="primary"
                            onClick={() => {
                              window.location.href = "/neworder/1/new/0";
                            }}
                          >
                            ثبت مشتری
                          </MDButton>
                        )}
                        {["supperadmin", "saleadmin", "productionadmin"].filter(
                          (a) => a == controller.userRole
                        ).length > 0 && (
                          <MDButton
                            style={{ float: "left" }}
                            variant="contained"
                            color="primary"
                            onClick={() => {
                              window.location.href = "/neworder/0/new/0";
                            }}
                          >
                            ثبت همکار
                          </MDButton>
                        )}
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox pt={3}>
                <LoadingOverlay
                  className="overlayclass"
                  active={loading}
                  spinner
                  text="لطفا کمی صبر کنید"
                >
                  <Grid container spacing={2} px={1} mb={2}>
                    <Grid item lg={10} md={10} xs={8}>
                      <TextField
                        autoFocus
                        id="search"
                        fullWidth
                        variant="outlined"
                        value={search}
                        placeholder="جستجو..."
                        onChange={(event) => {
                          setSearch(event.target.value);
                          if (event.target.value === "") {
                            setPage(0);
                            getData(rowsPerPage, 1, filter, "", sort);
                          }
                        }}
                        onKeyPress={(ev) => {
                          if (ev.key === "Enter") {
                            setPage(0);
                            getData(rowsPerPage, 1, filter, search, sort);
                          }
                        }}
                      />
                    </Grid>
                    <Grid item lg={2} md={2} xs={4}>
                      <MDButton
                        style={{ float: "left" }}
                        variant="outlined"
                        color="success"
                        onClick={() => {
                          if (modal) {
                            setFilter({});
                            getData(rowsPerPage, 1, {}, search, sort);
                          }
                          setModal(!modal);
                        }}
                      >
                        {modal === true ? "حذف فیلترها" : "فیلتر"}
                      </MDButton>
                    </Grid>
                  </Grid>
                  {modal && (
                    <>
                      <Grid container px={1} spacing={1}>
                        <Grid item lg={4} md={6} xs={12}>
                          <FormControl fullWidth variant="outlined">
                            <InputLabel id="material">جنس محصول</InputLabel>
                            <Select
                              dir="rtl"
                              id="material"
                              labelId="label-material"
                              label="جنس محصول"
                              onChange={(event) => {
                                const temp = filter;
                                temp.material = event.target.value;
                                setFilter(temp);
                                getData(rowsPerPage, 1, filter, search, sort);
                              }}
                            >
                              <MenuItem>
                                <em>NONE</em>
                              </MenuItem>
                              <MenuItem value="طلا">طلا</MenuItem>
                              <MenuItem value="نقره">نقره</MenuItem>
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                          <FormControl fullWidth variant="outlined">
                            <InputLabel id="type">نوع محصول</InputLabel>
                            <Select
                              dir="rtl"
                              id="type"
                              labelId="label-type"
                              label="نوع محصول"
                              // value={fields.type}
                              onChange={(event) => {
                                const temp = filter;
                                temp.type = event.target.value;
                                setFilter(temp);
                                getData(rowsPerPage, 1, filter, search, sort);
                              }}
                            >
                              <MenuItem>
                                <em>NONE</em>
                              </MenuItem>
                              {productTypes.map((item) => (
                                <MenuItem value={item}>{item}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                          <FormControl fullWidth variant="outlined">
                            <InputLabel id="buildType">نوع ساخت</InputLabel>
                            <Select
                              dir="rtl"
                              id="buildType"
                              labelId="label-buildType"
                              label="نوع ساخت"
                              // value={fields.buildType}
                              onChange={(event) => {
                                const temp = filter;
                                temp.buildType = event.target.value;
                                setFilter(temp);
                                getData(rowsPerPage, 1, filter, search, sort);
                              }}
                            >
                              <MenuItem>
                                <em>NONE</em>
                              </MenuItem>
                              {buildTypes.map((item) => (
                                <MenuItem value={item}>{item}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                          {collaborators && (
                            <Autocomplete
                              disablePortal
                              id="combo-box-demo"
                              options={collaborators}
                              //value={fields.collaborator}

                              onChange={(event, newValue) => {
                                const temp = filter;
                                temp.collaborator = newValue.id;
                                setFilter(temp);
                                getData(rowsPerPage, 1, filter, search, sort);
                                // const temp = fields;
                                // temp.collaborator = newValue.id;
                                // setFields(temp);
                                // setReload(new Date());
                              }}
                              renderInput={(params) => (
                                <TextField {...params} label="همکار سفارش دهنده" />
                              )}
                            />
                          )}
                        </Grid>
                        <Grid item lg={4} md={6} xs={12}>
                          <FormControl fullWidth variant="outlined">
                            <InputLabel id="plating">آبکاری</InputLabel>
                            <Select
                              dir="rtl"
                              id="plating"
                              labelId="label-plating"
                              label="آبکاری"
                              // value={filters.plating}
                              onChange={(event) => {
                                const temp = filter;
                                temp.plating = event.target.value;
                                setFilter(temp);
                                getData(rowsPerPage, 1, filter, search, sort);
                              }}
                            >
                              <MenuItem>
                                <em>NONE</em>
                              </MenuItem>
                              {platings.map((item) => (
                                <MenuItem value={item}>{item}</MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        {location.pathname === "/activeorders" && (
                          <Grid item lg={4} md={6} xs={12}>
                            <FormControl fullWidth variant="outlined">
                              <InputLabel id="orderState">وضعیت</InputLabel>
                              <Select
                                dir="rtl"
                                id="orderState"
                                labelId="label-orderState"
                                label="وضعیت"
                                onChange={(event) => {
                                  const temp = filter;
                                  temp.orderState = event.target.value;
                                  setFilter(temp);
                                  getData(rowsPerPage, 1, filter, search, sort);
                                }}
                              >
                                <MenuItem>
                                  <em>NONE</em>
                                </MenuItem>
                                {orderStates.map((item) => (
                                  <MenuItem value={item}>{item}</MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Grid>
                        )}
                        <Grid item lg={4} md={6} xs={12}>
                          <Grid container spacing={1}>
                            <Grid item lg={6} md={6} xs={6}>
                              <LocalizationProvider dateAdapter={AdapterJalali}>
                                <DatePicker
                                  label="تاریخ تحویل از"
                                  mask="____/__/__"
                                  value={filter.deliveryDate}
                                  onChange={(newValue) => {
                                    const temp = filter;
                                    temp.deliveryDate = newValue;
                                    setFilter(temp);
                                    getData(rowsPerPage, 1, filter, search, sort);
                                  }}
                                  renderInput={(params) => <TextField {...params} fullWidth />}
                                />
                              </LocalizationProvider>
                            </Grid>
                            <Grid item lg={6} md={6} xs={6}>
                              <LocalizationProvider dateAdapter={AdapterJalali}>
                                <DatePicker
                                  label="تاریخ تحویل تا"
                                  mask="____/__/__"
                                  value={filter.deliveryDate2}
                                  onChange={(newValue) => {
                                    const temp = filter;
                                    temp.deliveryDate2 = newValue;
                                    setFilter(temp);
                                    getData(rowsPerPage, 1, filter, search, sort);
                                  }}
                                  renderInput={(params) => <TextField {...params} fullWidth />}
                                />
                              </LocalizationProvider>
                            </Grid>
                          </Grid>
                        </Grid>
                        {/* {location.pathname === "/activeorders" && ( */}
                        <Grid item lg={4} md={6} xs={12} style={{ justifyContent: "center" }}>
                          <FormControlLabel
                            control={
                              <Checkbox
                                onChange={() => {
                                  const temp = filter;
                                  temp.canceled = !filter.canceled;
                                  setFilter(temp);
                                  getData(rowsPerPage, 1, filter, search, sort);
                                }}
                                color="secondary"
                                size="larg"
                              />
                            }
                            label="سفارش های کنسل شده"
                          />
                        </Grid>
                        {/* )} */}
                      </Grid>
                    </>
                  )}
                  <Grid container px={1} mt={1} spacing={1}>
                    <Grid item lg={2} md={3} xs={3}>
                      {sort.deliveryDate && sort.deliveryDate === 1 && (
                        <Button
                          endIcon={<ArrowDownwardIcon />}
                          onClick={() => {
                            const temp = sort;
                            temp.deliveryDate = undefined;
                            setSort(temp);
                            getData(rowsPerPage, 1, filter, search, temp);
                          }}
                          variant="text"
                        >
                          تاریخ تحویل
                        </Button>
                      )}
                      {sort.deliveryDate && sort.deliveryDate === -1 && (
                        <Button
                          endIcon={<ArrowUpwardIcon />}
                          onClick={() => {
                            const temp = sort;
                            temp.deliveryDate = 1;
                            setSort(temp);
                            getData(rowsPerPage, 1, filter, search, temp);
                          }}
                          variant="text"
                        >
                          تاریخ تحویل
                        </Button>
                      )}
                      {(!sort.deliveryDate || !sort.deliveryDate) && (
                        <Button
                          onClick={() => {
                            const temp = sort;
                            temp.deliveryDate = -1;
                            setSort(temp);
                            getData(rowsPerPage, 1, filter, search, temp);
                          }}
                          variant="text"
                        >
                          تاریخ تحویل
                        </Button>
                      )}
                    </Grid>
                    {location.pathname === "/deactiveorders" && (
                      <>
                        <Grid item lg={2} md={3} xs={3}>
                          {sort.endDate && sort.endDate === 1 && (
                            <Button
                              endIcon={<ArrowDownwardIcon />}
                              onClick={() => {
                                const temp = sort;
                                temp.endDate = undefined;
                                setSort(temp);
                                getData(rowsPerPage, 1, filter, search, temp);
                              }}
                              variant="text"
                            >
                              تاریخ تحویل نهایی
                            </Button>
                          )}
                          {sort.endDate && sort.endDate === -1 && (
                            <Button
                              endIcon={<ArrowUpwardIcon />}
                              onClick={() => {
                                const temp = sort;
                                temp.endDate = 1;
                                setSort(temp);
                                getData(rowsPerPage, 1, filter, search, temp);
                              }}
                              variant="text"
                            >
                              تاریخ تحویل نهایی
                            </Button>
                          )}
                          {(!sort.endDate || !sort.endDate) && (
                            <Button
                              onClick={() => {
                                const temp = sort;
                                temp.endDate = -1;
                                setSort(temp);
                                getData(rowsPerPage, 1, filter, search, temp);
                              }}
                              variant="text"
                            >
                              تاریخ تحویل نهایی
                            </Button>
                          )}
                        </Grid>
                        <Grid item lg={2} md={3} xs={3}>
                          {sort.collaboratorDate && sort.collaboratorDate === 1 && (
                            <Button
                              endIcon={<ArrowDownwardIcon />}
                              onClick={() => {
                                const temp = sort;
                                temp.collaboratorDate = undefined;
                                setSort(temp);
                                getData(rowsPerPage, 1, filter, search, temp);
                              }}
                              variant="text"
                            >
                              تاریخ تحویل به همکار
                            </Button>
                          )}
                          {sort.collaboratorDate && sort.collaboratorDate === -1 && (
                            <Button
                              endIcon={<ArrowUpwardIcon />}
                              onClick={() => {
                                const temp = sort;
                                temp.collaboratorDate = 1;
                                setSort(temp);
                                getData(rowsPerPage, 1, filter, search, temp);
                              }}
                              variant="text"
                            >
                              تاریخ تحویل به همکار
                            </Button>
                          )}
                          {(!sort.collaboratorDate || !sort.collaboratorDate) && (
                            <Button
                              onClick={() => {
                                const temp = sort;
                                temp.collaboratorDate = -1;
                                setSort(temp);
                                getData(rowsPerPage, 1, filter, search, temp);
                              }}
                              variant="text"
                            >
                              تاریخ تحویل به همکار
                            </Button>
                          )}
                        </Grid>
                      </>
                    )}
                    <Grid item lg={2} md={3} xs={3}>
                      {sort.thickness && sort.thickness === 1 && (
                        <Button
                          endIcon={<ArrowDownwardIcon />}
                          onClick={() => {
                            const temp = sort;
                            temp.thickness = undefined;
                            setSort(temp);
                            getData(rowsPerPage, 1, filter, search, temp);
                          }}
                          variant="text"
                        >
                          ضخامت
                        </Button>
                      )}
                      {sort.thickness && sort.thickness === -1 && (
                        <Button
                          endIcon={<ArrowUpwardIcon />}
                          onClick={() => {
                            const temp = sort;
                            temp.thickness = 1;
                            setSort(temp);
                            getData(rowsPerPage, 1, filter, search, temp);
                          }}
                          variant="text"
                        >
                          ضخامت
                        </Button>
                      )}
                      {(!sort.thickness || !sort.thickness) && (
                        <Button
                          onClick={() => {
                            const temp = sort;
                            temp.thickness = -1;
                            setSort(temp);
                            getData(rowsPerPage, 1, filter, search, temp);
                          }}
                          variant="text"
                        >
                          ضخامت
                        </Button>
                      )}
                    </Grid>
                  </Grid>
                  <TableContainer component={Paper} style={{ borderWidth: 1, borderColor: "#000" }}>
                    <Table>
                      <TableBody>
                        {datas.map((row, index) => (
                          <TableRow
                            sx={{ "& > *": { borderBottom: "unset" } }}
                            key={row.name}
                            style={{
                              borderWidth: 1,
                              borderColor: "#000",
                              borderRadius: 5,
                            }}
                          >
                            <TableCell>
                              <div className="borderdtbltr">
                                <Grid
                                  className={
                                    row.orderState === "در انتظار طراحی"
                                      ? "tblhrader"
                                      : row.orderState === "در انتظار ساخت"
                                      ? "tblhrader1"
                                      : "tblhrader2"
                                  }
                                  container
                                  px={1}
                                >
                                  <Grid
                                    lg={2}
                                    md={3}
                                    xs={4}
                                    style={{
                                      minWidth: 120,
                                      verticalAlign: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <Checkbox
                                      icon={
                                        <StarBorderIcon
                                          style={{
                                            width: 30,
                                            height: 30,
                                            borderColor: "transparent",
                                          }}
                                        />
                                      }
                                      checkedIcon={
                                        <StarIcon
                                          style={{
                                            width: 30,
                                            height: 30,
                                            color: "#ebcf34",
                                            borderColor: "transparent",
                                          }}
                                        />
                                      }
                                      onChange={() => {
                                        handleUpdatePinClick(row.id, row.pin);
                                      }}
                                      color="secondary"
                                      defaultChecked={row.pin}
                                      size="medium"
                                      style={{
                                        width: 45,
                                        height: 45,
                                        position: "absolute",
                                        marginTop: -20,
                                        marginRight: -25,
                                      }}
                                    />

                                    {row.picture && (
                                      <div
                                        style={{
                                          width: 140,
                                          height: 140,
                                          maxHeight: 140,
                                          maxWidth: 140,
                                          resize: "center",
                                          padding: 5,
                                          justifyContent: "center",
                                          alignItems: "center",
                                          overflow: "hidden",
                                        }}
                                      >
                                        <ImageViewer>
                                          <img
                                            style={{
                                              width: "100%",
                                              height: "100%",
                                              resize: "cover",
                                            }}
                                            src={`${config.fileserver}product/${row.picture}`}
                                            alt="گالری محتشم"
                                          />
                                        </ImageViewer>
                                      </div>
                                    )}
                                    {!row.picture && (
                                      <Image
                                        source={require("../../assets/images/logo-ct.png")}
                                        style={{
                                          minWidth: 140,
                                          minHeight: 140,
                                          maxHeight: 140,
                                          maxWidth: 140,
                                          width: "100%",
                                          resize: "center",
                                          padding: 10,
                                        }}
                                      />
                                    )}
                                    {(controller.userRole === "supperadmin" ||
                                      controller.userRole === "saleadmin" ||
                                      (controller.userRole === "saller" &&
                                        location.pathname === "/activeorders") ||
                                      (controller.userRole === "designer" &&
                                        location.pathname === "/activeorders") ||
                                      (controller.userRole === "productionadmin" &&
                                        location.pathname === "/activeorders")) && (
                                      <MDButton
                                        variant="gradient"
                                        color="info"
                                        size="small"
                                        onClick={() => {
                                          navigate(`/neworder/${row.endUser}/${row.id}/2`);
                                        }}
                                      >
                                        ویرایش
                                      </MDButton>
                                    )}
                                    {controller.userRole === "supperadmin" && (
                                      <MDButton
                                        variant="gradient"
                                        color="info"
                                        size="small"
                                        style={{ marginRight: 5 }}
                                        onClick={() => {
                                          navigate(`/orderlog/${row.id}`);
                                        }}
                                      >
                                        LOG
                                      </MDButton>
                                    )}
                                  </Grid>
                                  <Grid
                                    container
                                    lg={10}
                                    md={9}
                                    xs={8}
                                    onClick={() => {
                                      if (
                                        controller.userRole === "supperadmin" ||
                                        controller.userRole === "saleadmin" ||
                                        controller.userRole === "saller" ||
                                        controller.userRole === "designer" ||
                                        controller.userRole === "productionadmin" ||
                                        controller.userRole === "production"
                                      ) {
                                        navigate(`/neworder/${row.endUser}/${row.id}/1`);
                                        // window.location.href = `/neworder/${row.endUser}/${row.id}`;
                                      }
                                    }}
                                  >
                                    {/* <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                       <b style={{ color: "#000066" }}> تاریخ ثبت : </b>
                                      {row.createdAt}
                                    </Grid> */}
                                    {location.pathname === "/deactiveorders" && (
                                      <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                        <b style={{ color: "#000066" }}> تاریخ تحویل به همکار: </b>
                                        {row.collaboratorDate}
                                      </Grid>
                                    )}
                                    {location.pathname === "/deactiveorders" && row.endDate && (
                                      <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                        <b style={{ color: "#000066" }}> تاریخ تحویل به مشتری: </b>
                                        {row.endDate}
                                      </Grid>
                                    )}

                                    {location.pathname === "/activeorders" && row.deliveryDate && (
                                      <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                        <b style={{ color: "#000066" }}> تاریخ تحویل : </b>
                                        {row.deliveryDate}
                                      </Grid>
                                    )}
                                    <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                      <b style={{ color: "#000066" }}> شرح محصول: </b>
                                      {row.explanation}
                                    </Grid>
                                    <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                      <b style={{ color: "#000066" }}> سفارش دهنده: </b>
                                      {row.customer}
                                    </Grid>
                                    <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                      <b style={{ color: "#000066" }}> نوع ساخت: </b>
                                      {row.buildType}
                                    </Grid>
                                    <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                      <b style={{ color: "#000066" }}> جنس محصول: </b>
                                      {row.material}
                                    </Grid>
                                    {location.pathname === "/activeorders" && (
                                      <>
                                        <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                          <b style={{ color: "#000066" }}> وزن کل درخواستی: </b>
                                          {row.weight}
                                        </Grid>
                                        <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                          <b style={{ color: "#000066" }}> وزن پلاک درخواستی: </b>
                                          {row.pelakWeight}
                                        </Grid>
                                        <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                          <b style={{ color: "#000066" }}>وزن زنجیر درخواستی: </b>
                                          {row.zanjirWeight}
                                        </Grid>
                                      </>
                                    )}
                                    {location.pathname === "/deactiveorders" && (
                                      <>
                                        <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                          <b style={{ color: "#000066" }}>وزن تحویلی به همکار: </b>
                                          {row.collaboratorWeight}
                                        </Grid>
                                        <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                          <b style={{ color: "#000066" }}>وزن تحویلی به مشتری: </b>
                                          {row.endWeight}
                                        </Grid>
                                      </>
                                    )}
                                    {location.pathname === "/activeorders" && (
                                      <>
                                        <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                          <b style={{ color: "#000066" }}> ابعاد: </b>
                                          {` ${row.width} * ${row.height}`}
                                        </Grid>

                                        <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                          <b style={{ color: "#000066" }}> ضخامت:</b>
                                          {row.thickness}
                                        </Grid>
                                        <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                          <b style={{ color: "#000066" }}> آبکاری:</b>
                                          {row.plating}
                                        </Grid>
                                      </>
                                    )}
                                    {location.pathname === "/activeorders" && (
                                      <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                        <b style={{ color: "#000066" }}> وضعیت سفارش:</b>
                                        <b style={{ color: "#000066" }}>{row.orderState}</b>
                                      </Grid>
                                    )}

                                    {/* <Grid lg={4} md={6} xs={12} style={{ textAlign: "right" }}>
                                       <b style={{ color: "#000066" }}> تاریخ تحویل نهایی: </b>
                                      {row.endDate}
                                    </Grid> */}
                                  </Grid>
                                  {/* <Grid
                                    lg={1}
                                    md={1}
                                    xs={1}
                                    style={{
                                      alignItems: "flex-start",
                                      justifyContent: "flex-start",
                                    }}
                                    onClick={() => {
                                      if (open === index) {
                                        setOpen();
                                      } else {
                                        setOpen(index);
                                      }
                                    }}
                                  >
                                    {index !== open && (
                                      <KeyboardArrowDownIcon
                                        fontSize="small"
                                        style={{
                                          lineHeight: "100%",
                                          fontSize: 20,
                                          width: 35,
                                          height: 35,
                                        }}
                                      />
                                    )}
                                    {index === open && (
                                      <KeyboardArrowUp
                                        style={{
                                          lineHeight: "100%",
                                          fontSize: 20,
                                          width: 35,
                                          height: 35,
                                        }}
                                      />
                                    )}
                                  </Grid> */}
                                </Grid>
                                {/* <Grid
                                  container
                                  lg={12}
                                  md={12}
                                  xs={12}
                                  style={{ textAlign: "left" }}
                                >
                                  <Grid
                                    item
                                    style={{
                                      width: "calc(100% - 260px)",
                                    }}
                                  />
                                  <Grid
                                    item
                                    style={{
                                      width: 120,
                                      heigt: 50,
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      if (open === index) {
                                        setOpen();
                                      } else {
                                        setOpen(index);
                                      }
                                    }}
                                  >
                                    {index === open ? "بستن" : "بیشتر"}
                                  </Grid>
                                  <Grid
                                    item
                                    style={{
                                      width: 120,
                                      heigt: 50,
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      window.location.href = `/neworder/${row.endUser}/${row.id}`;
                                    }}
                                  >
                                    ویرایش
                                  </Grid>
                                </Grid> */}
                              </div>
                            </TableCell>
                          </TableRow>
                        ))}
                        {emptyRows > 0 && (
                          <TableRow style={{ height: 0 }}>
                            <TableCell />
                          </TableRow>
                        )}
                      </TableBody>
                      <TableFooter>
                        <TableRow>
                          <TablePagination
                            rowsPerPageOptions={[5, 10, 25, { label: "همه", value: -1 }]}
                            count={count}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            SelectProps={{
                              inputProps: {
                                "aria-label": "سطر در هر صفحه",
                              },
                              native: true,
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            ActionsComponent={TablePaginationActions}
                          />
                        </TableRow>
                      </TableFooter>
                    </Table>
                  </TableContainer>
                </LoadingOverlay>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Orders;
